export default {
  getHead: () => {
    return [{name: '회사명'}, {name: '사업장명'}, {name: '평가종류'},  {name: '공종명'}, {name: '평가자'}, {name: '작성일'}]
  } ,
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: return func.getContent(value).stdInfo.section // 회사명
        case 1: return func.getContent(value).stdInfo.field_name // 사업장명
        case 2: return func.getContent(value).inputA_1 // 평가종류
        case 3: return func.getContent(value).inputA_3 // 공종명
        case 4: return func.getContent(value).inputA_2 // 평가자
        case 5: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { disasterType: nav.value.disasterType, searchType: nav.value.searchType,  searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    const returnData = []

    if (nav.value.disasterType) returnData.push('content$body.disasterString*[:default_disaster]')

    switch (nav.value.searchType) {
      case '회사명': returnData.push('content$body.stdInfo.section*%[:default_skw]%%'); break
      case '사업장명': returnData.push('content$body.stdInfo.field_name*%[:default_skw]%'); break
      case '평가종류': returnData.push('content$body.inputA_1*%[:default_skw]%'); break
      case '공종명': returnData.push('content$body.inputA_1*%[:default_skw]%'); break
      case '평가자': returnData.push('content$body.inputA_1*%[:default_skw]%'); break
    }

    return returnData
  },
}
